import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output } from '@angular/core';

import { Store, select } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { TWorkspacesById } from 'src/app/project/modules/workspace/workspace.model';
import { TFilters } from '../site-filter.model';

import { ActiveService } from 'src/app/project/services/active/active.service';

import { checkCustomWorkspaceId } from 'src/app/project/modules/workspace/workspace';
import { logEventInGTAG } from 'src/app/project/services/analytics/google-analytics';
import {
  EGoogleEventCategory,
  EGoogleEventQuickFilter,
} from 'src/app/project/services/analytics/google-analytics.consts';
import { EIconPath } from 'src/app/project/shared/enums/icons.enum';
import { EStore } from '../../../shared/enums/store.enum';
import { TTagSelectOptions } from '../../tags/tag-select/tag-select.component';

@Component({
  selector: 'pp-filter-tags',
  templateUrl: './filter-tags.component.html',
  styleUrls: ['./filter-tags.component.scss'],
  standalone: false,
})
export class FilterTagsComponent implements OnChanges, OnDestroy {
  @Input() ppFilters: TFilters;
  @Input() ppHasLargeTitle: boolean = false;

  @Output() ppOnValueChange = new EventEmitter();
  @Output() ppOnExcludedTagsValueChange = new EventEmitter();

  filters: TFilters;
  tagSelectOptionsForInclude: TTagSelectOptions;
  tagSelectOptionsForExclude: TTagSelectOptions;
  EIconPath = EIconPath;

  private readonly destroy$ = new Subject<void>();
  private workspaces$ = new Observable<TWorkspacesById>();
  workspaceId: string;

  constructor(
    private store: Store<{
      workspaces: TWorkspacesById;
    }>,
    private activeService: ActiveService,
  ) {
    this.workspaces$ = this.store.pipe(select(EStore.WORKSPACES));

    this.filters = this.ppFilters;

    this.workspaces$.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.workspaceId = checkCustomWorkspaceId() || this.activeService.getActiveWorkspaceId();
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
  }

  ngOnChanges() {
    this.filters = this.ppFilters;

    this.setTagSelectOptions();
  }

  private setTagSelectOptions(): void {
    this.tagSelectOptionsForInclude = {
      showIcon: false,
      noTagRemovedDebounceTime: true,
      singleLineInput: true,
      combinedTags: this.filters.tags.combinedTags,
    };

    this.tagSelectOptionsForExclude = {
      showIcon: false,
      noTagRemovedDebounceTime: true,
      singleLineInput: true,
      combinedTags: this.filters.excludedTags.combinedTags,
    };
  }

  selectTags(tags: string[]): void {
    if (tags.length > 0 && this.filters.tags.value.length !== tags.length) {
      this.triggerGA('INC');
    }
    if (this.filters.tags) {
      this.filters.tags.value = tags;
    }

    this.ppOnValueChange.emit();
  }

  triggerGA(type: 'INC' | 'EXC'): void {
    logEventInGTAG(
      type === 'INC'
        ? EGoogleEventQuickFilter.INCLUDING_TAGS
        : EGoogleEventQuickFilter.EXCLUDING_TAGS,
      {
        source: EGoogleEventCategory.QUICK_FILTER,
      },
    );
  }

  selectExcludedTags(tags: string[]): void {
    if (tags.length > 0 && this.filters.excludedTags.value.length !== tags.length) {
      this.triggerGA('EXC');
    }
    if (this.filters.excludedTags.value) {
      this.filters.excludedTags.value = tags;
    }

    this.ppOnValueChange.emit();
    this.ppOnExcludedTagsValueChange.emit();
  }

  clearAll(): void {
    this.filters.tags = { value: [], combinedTags: false };

    this.ppOnValueChange.emit();
  }

  clearAllExcluded(): void {
    this.filters.excludedTags = { value: [], combinedTags: false };

    this.ppOnValueChange.emit();
    this.ppOnExcludedTagsValueChange.emit();
  }
}
